import { useSelector } from 'react-redux';

import { SessionType } from '@shared';
import { selectFeatureFlags, selectSession } from '@client/model/selectors';

export interface SessionFlags {
  isWizardSession: boolean;
  isEdjPilotAdvisor: boolean;
}

export function useSessionFlags(): SessionFlags {
  const session = useSelector(selectSession);
  const featureFlags = useSelector(selectFeatureFlags);

  return {
    isWizardSession: session.sessionType === SessionType.wizard,
    isEdjPilotAdvisor: !!featureFlags.edjPilotAdvisor,
  };
}
